<template>
  <v-main>
    <EditDialog ref="dialog" @reload="$refs.report.reload()" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
      :rememberLastClick="true"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Nova Marca/Modelo...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { BrandModel } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import EditDialog from './EditDialog.vue'
import { brDt } from 'oderon-commons/src/formatters.js'

export default {
  pageTitle: 'Marcas/Modelos',
  components: {
    GenericReport,
    EditDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Marcas/Modelos',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos',
            defVal: false
          }
        ]
      },
      adapterSpec: {
        defOrder: 'name asc',
        columns: [
          { t: 'ID|', w: 100, d: 'id', color: '#cccccc' },
          { t: 'Nome', d: 'name' },
          { t: 'Atualizado em|', d: 'updatedAt', f: brDt, w: 250 },
          { t: 'Desativado em|', d: 'deletedAt', f: brDt, w: 250 }
        ]
      },

      // checkboxes marcados (para duplicar)
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDeactivate(),
          disabled: len < 1
        },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.checkDownload()
        }
      ]
    }
  },
  methods: {
    async fetchData(apiParams) {
      let { count, rows } = await BrandModel.findAll(apiParams)
      return { count, rows }
    },

    async newRow() {
      let label = 'Digite o nome da nova marca/modelo'
      let name = await this.$prompt({ label })
      if (name != null) {
        let row = await this.$rootLoading(async () => {
          return BrandModel.save({ name })
        })
        this.$refs.report.reload()
        if (row != null) this.selectRow({ row })
      }
    },

    selectRow({ row /*, isMiddle*/ }) {
      // if (isMiddle) window.open(`/#/setup/brand-models/${row.id}`, '_blank')
      // else this.$router.push(`/setup/brand-models/${row.id}`)
      // else
      this.$refs.dialog.open(row.id)
    },

    async confirmDeactivate() {
      let res = await this.$confirmDeactivate({
        strings: 'marca/modelo,marca/modelos;a',
        len: this.selectedIds.length
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await BrandModel.delete(id)
          }
          this.selectedIds = []
          this.$snack('Desativada(s) com sucesso')
          this.$refs.report.reload()
        })
      }
    }
  }
}
</script>

<style></style>
